import { useStyletron } from 'baseui';
import { faCheckCircle, faEdit, faEnvelope, faTrashCan, faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faCheckDouble, faClipboardCheck, faSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NPRequestStatus } from '@gtintel/platform-types';
import { NPRequestStatusColourMap, hexToRGB } from '@gtintel/platform-utils';
const statusToText = status => {
  switch (status) {
    case NPRequestStatus.Draft:
      return 'Draft';
    case NPRequestStatus.Sent:
      return 'Pending Acceptance';
    case NPRequestStatus.Declined:
      return 'Declined';
    case NPRequestStatus.Accepted:
      return 'Awaiting Activation';
    case NPRequestStatus.Cancelled:
      return 'Cancelled';
    case NPRequestStatus.Assigned:
      return 'Activated';
    case NPRequestStatus.AcceptedCancelled:
      return 'Cancelled';
    case NPRequestStatus.Submitted:
      return 'Submitted';
    case NPRequestStatus.Finished:
      return 'Finished';
    default:
      return 'Unknown';
  }
};
const RequestStatusIcon = ({
  status,
  overrides
}) => {
  const [css] = useStyletron();
  const colour = NPRequestStatusColourMap[status];
  let icon;
  let secondaryIcon = null;
  let secondaryColour;
  switch (status) {
    case NPRequestStatus.Draft:
      icon = faEdit;
      break;
    case NPRequestStatus.Sent:
      icon = faEnvelope;
      break;
    case NPRequestStatus.Declined:
      icon = faXmarkCircle;
      break;
    case NPRequestStatus.Accepted:
      icon = faCheck;
      break;
    case NPRequestStatus.Cancelled:
      icon = faTrashCan;
      break;
    case NPRequestStatus.Assigned:
      icon = faCheckCircle;
      break;
    case NPRequestStatus.AcceptedCancelled:
      icon = faSlash;
      secondaryIcon = faCheckCircle;
      secondaryColour = '#a1a1a1';
      break;
    case NPRequestStatus.Submitted:
      icon = faClipboardCheck;
      break;
    case NPRequestStatus.Finished:
      icon = faCheckDouble;
      break;
    default:
      icon = faTrashCan;
      break;
  }
  const statusLower = NPRequestStatus[status].toLowerCase();
  return <div className={css({
    alignItems: 'center',
    display: 'flex',
    gap: '8px',
    height: '24px',
    justifyContent: 'center',
    width: '24px',
    ...overrides
  })} data-testid={`status-icon-${statusLower}`}>
      {secondaryIcon ? <span className="fa-layers fa-fw">
          <FontAwesomeIcon icon={secondaryIcon} style={{
        color: secondaryColour
      }} size={'xl'} title={statusLower} />
          <FontAwesomeIcon icon={icon} style={{
        color: colour
      }} size={'xl'} title={statusLower} />
        </span> : <FontAwesomeIcon icon={icon} style={{
      color: colour
    }} size={'xl'} title={statusLower} />}
    </div>;
};
export const RequestStatusPill = ({
  status,
  showIcon = true
}) => {
  const [css] = useStyletron();
  const background = NPRequestStatusColourMap[status];
  const colour = NPRequestStatusColourMap[status];
  return <span className={css({
    background: 'white',
    borderRadius: '24px'
  })}>
      <div className={css({
      background: `${hexToRGB(background, 0.1)}`,
      borderRadius: '24px',
      color: colour,
      display: 'flex',
      flexFlow: 'row nowrap',
      fontSize: '14px',
      gap: '8px',
      height: 'fit-content',
      padding: '8px 12px'
    })}>
        {!!showIcon && <RequestStatusIcon status={status} />}
        <span>{statusToText(status)}</span>
      </div>
    </span>;
};
export default RequestStatusIcon;